<template>
  <section>
    <b-navbar toggleable="lg" class="submenu">
      <b-nav>
        <add-invite @invitedResult="invitedResult">
          <b-nav-item>
            <i class="fal fa-plus-circle" />
            <span>{{ $t('TEAM.ADD_USER') }}</span>
          </b-nav-item>
        </add-invite>
        <b-nav-item
          active-class="active"
          :to="{ name: 'TeamUsers' }"
          v-b-tooltip.hover
          :title="$t('TEAM.USERS')"
        >
          <i class="fal fa-users" />
          <span>{{ $t('TEAM.USERS') }}</span>
        </b-nav-item>
        <b-nav-item
          active-class="active"
          :to="{ name: 'TeamInvites' }"
          v-b-tooltip.hover
          :title="$t('TEAM.INVITES')"
        >
          <i class="fal fa-user-plus" />
          <span>{{ $t('TEAM.INVITES') }}</span>
        </b-nav-item>
        <b-nav-item
          v-if="1 == 0"
          active-class="active"
          :to="{ name: 'TeamPayments' }"
          v-b-tooltip.hover
          :title="$t('TEAM.PAYMENTS')"
        >
          <i class="fal fa-dot-circle" />
          <span>{{ $t('TEAM.PAYMENTS') }}</span>
        </b-nav-item>
        <b-nav-item
          active-class="active"
          :to="{ name: 'TeamApplications' }"
          v-b-tooltip.hover
          :title="$t('TEAM.APPLICATIONS')"
        >
          <i class="fal fa-chart-network" />
          <span>{{ $t('TEAM.APPLICATIONS') }}</span>
        </b-nav-item>
      </b-nav>
    </b-navbar>

    <div class="container-fluid mt-2">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </section>
</template>
<script>
import AddInvite from "@/components/Team/AddInvite";
export default {
  components: {
    AddInvite
  },
  data() {
    return {};
  },
  methods: {
    invitedResult: function() {

    }
  },
  mounted: function() {}
};
</script>
<style>
</style>